<template>
  <component
    :is="type === 'fixed' ? Teleport : 'div'"
    v-if="isChinese()"
    to="body"
  >
    <div
      :class="[
        'x-attract flex flex-col justify-center items-center',
        { fixed: type === 'fixed' },
      ]"
    >
      <Resource class="qrcode" :src="src"></Resource>
      <div class="words text-center">
        加入有言创作社群 <br />获取最新资讯福利
      </div>
    </div>
  </component>
</template>

<script setup lang="ts">
import { Teleport } from 'vue'
import { AttractSource } from './constant'
import Resource from '~/components/resource/index'
import { transformImage } from '~/utils'

const props = withDefaults(
  defineProps<{
    source: AttractSource
    type: 'inline' | 'fixed'
  }>(),
  {
    type: 'inline',
  }
)

const src = computed(() =>
  transformImage(
    getFeUrl(`/youyan-platform/png/qrcode/${props.source}-qrcode.png`),
    {},
    'minute'
  )
)
</script>

<style lang="scss" scoped>
.fixed {
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(21, 46, 106, 0.08);
  border-radius: 12px;
  padding: 24px;
  position: fixed;
  left: 20px;
  bottom: 320px;
}
.qrcode {
  width: 132px;
  height: 132px;
}
.words {
  margin-top: 6px;
  font-size: 12px;
  color: rgb(5, 5, 18, 0.6);
  line-height: 18px;
}
</style>
